export const CorporateFooter = () => (
  <footer
    className="arx-corporate-shell__footer"
    aria-label="Rodapé institucional"
  >
    <span>ARANOX Digital Platform</span>
    <span aria-hidden="true">•</span>
    <span>Engenharia, operações e inteligência</span>
  </footer>
);
